<template>
  <div>
    <button
      v-if="showRemove"
      class="core-block-close-icon z-20 cursor-pointer"
      :title="$t('project.general.sections.usage_definition.usage.tip.remove')"
      @click.prevent="emit('remove')">
      <IconX class="h-4 w-4" stroke="1.8" />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { IconX } from '@tabler/icons-vue'

defineProps<{
  showRemove: boolean
}>()

const emit = defineEmits<{
  remove: []
}>()
</script>

<style lang="postcss" scoped>
.core-block-close-icon {
  @apply absolute top-2 right-2 flex h-6 w-6 items-center justify-center text-neutral-500 transition-colors hover:text-primary-dark;
}
</style>
